<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="zoopModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Zoop / Split</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!split_zoop_valid" icon="fa fa-info-circle" title="Nenhum lançamento selecionado para gerar o Split Zoop." />

                        <div v-else>
                            <div class="alert alert-info d-flex justify-content-between" v-if="split_zoop_valid.lista">
                                <div>
                                    Recibo #{{ split_zoop_valid.lista.id_pagamento_atendimento }}
                                    <div class="small text-muted" v-if="split_zoop_valid.ipa && split_zoop_valid.ipa.js_outros && split_zoop_valid.ipa.js_outros.zoop && split_zoop_valid.ipa.js_outros.zoop.transaction_id">
                                        {{ split_zoop_valid.ipa.js_outros.zoop.transaction_id }}
                                    </div>
                                </div>
                                <div class="text-right">
                                    <div v-if="valor_total">
                                        {{ $util.formatMoeda(valor_total) }}
                                    </div>
                                    <div class="small text-muted" v-if="split_zoop_valid.realizados && split_zoop_valid.realizados.length && split_zoop_valid.ipa.dc_valor > 0">
                                        {{ $util.formatMoeda(split_zoop_valid.ipa.dc_valor) }}
                                    </div>
                                    <div class="small text-right" v-if="split_zoop_valid.ipa.forma_pagamento">
                                        {{ split_zoop_valid.ipa.forma_pagamento.search }}
                                    </div>
                                </div>
                            </div>

                            <!-- Split Realizado -->

                            <template v-if="split_zoop_valid.realizados">
                                <div class="card">
                                    <div class="card-header">
                                        Split Realizado                          
                                    </div>
                                    <table class="table table-sm table-hover small mb-0">
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>Forma</th>
                                                <th>Destino</th>
                                                <th>#</th>
                                                <th></th>
                                                <th class="text-right">Valor</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(realizado, irz) in split_zoop_valid.realizados" :key="'RZ' + irz">
                                                <td>{{ realizado.id_item_pagamento_atendimento }}</td>
                                                <td>{{ realizado.forma_pagamento.search }}</td>
                                                <td>{{ realizado.unid_nf 
                                                    ? realizado.unid_nf.st_nome : 
                                                    ( realizado.medico_split ? realizado.medico_split.st_nome_exibicao : '') 
                                                }}</td>
                                                <td>
                                                    {{ 
                                                        ( realizado.js_outros && realizado.js_outros.zoop && realizado.js_outros.zoop.id_atendimento ) 
                                                            ? '#' + realizado.js_outros.zoop.id_atendimento 
                                                            : ( 
                                                                ( realizado.js_outros && realizado.js_outros.zoop && realizado.js_outros.zoop.atends ) 
                                                                    ? realizado.js_outros.zoop.atends 
                                                                    : '' 
                                                            ) 
                                                    }}
                                                </td>
                                                <td>
                                                    {{ 
                                                        ( realizado.js_outros && realizado.js_outros.zoop && realizado.js_outros.zoop.tipo ) 
                                                            ? realizado.js_outros.zoop.tipo 
                                                            : '' 
                                                    }}
                                                </td>
                                                <td class="text-right">{{ $util.formatMoeda(realizado.dc_valor) }}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th colspan="5">Total</th>
                                                <th class="text-right">{{ $util.formatMoeda(split_zoop_valid.realizados.reduce((acc, r) => acc + r.dc_valor, 0)) }}</th>
                                            </tr>
                                            <tr v-if="split_zoop_valid.ipa.dc_valor > 0">
                                                <th colspan="5">Não Splitado</th>
                                                <th class="text-right">{{ $util.formatMoeda(split_zoop_valid.ipa.dc_valor) }}</th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </template>
                                            
                            <template v-else>

                                <table class="table table-sm table-hover" v-if="split_zoop_valid.splits">
                                    <thead>
                                        <tr>
                                            <th>Destino</th>
                                            <th>Id</th>
                                            <th class="text-right">Valor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(split, isx) in split_zoop_valid.splits" :key="isx">
                                            <td>{{ split.nome }}</td>
                                            <td>{{ split.seller }}</td>
                                            <td class="text-right"><span v-if="split.valor">{{ $util.formatMoeda(split.valor / 100) }}</span></td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div v-if="split_zoop_valid.splits_realizados && split_zoop_valid.splits_realizados.length == 1">
                                    <table class="table table-sm table-hover">
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>Processar Taxa</th>
                                                <th class="text-right"></th>
                                                <th class="text-right">Percent</th>
                                                <th class="text-right">Valor</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(split, isx) in split_zoop_valid.splits_realizados[0].splits" :key="'R' + isx">
                                                <td>{{ split.recipient }}</td>
                                                <td>{{ split.charge_processing_fee ? 'S' : 'N' }}</td>
                                                <td class="text-right"><template v-if="split.amount">{{ $util.formatMoeda(split.amount / 100) }}</template></td>
                                                <td class="text-right"><template v-if="split.percentage">{{ $util.formatMoeda(split.percentage, 6, 2) }}%</template></td>
                                                <td class="text-right"><template v-if="split_zoop_valid.ipa && split_zoop_valid.ipa.dc_valor">{{ $util.formatMoeda(split_zoop_valid.ipa.dc_valor * (split.percentage / 100)) }}</template></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </template>

                            <div class="card">
                                <div class="card-header">
                                    Atendimento                          
                                </div>
                                <table class="table table-hover table-sm small mb-0">
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Data</th>
                                            <th>Procedimento</th>
                                            <th>Profissional</th>
                                            <th>Rateio</th>
                                            <th class="text-right">Valor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(atp, iax) in lista_atendimentos" :key="iax">
                                            <td>#{{ atp.id_atendimento }}</td>
                                            <td>{{ $util.getFormatDate(atp.dt_inicio) }} {{ atp.dt_inicio.slice(11, 16) }}</td>
                                            <td>{{ atp.procedimento.search }}</td>
                                            <td>{{ atp.medico.search }}</td>
                                            <td>
                                                <a href="#" @click.prevent="ver_rateio(atp)" class="card-link">
                                                    #{{ atp.id_rateio_medico }}    
                                                </a>

                                                <span class="badge badge-light ml-1" v-if="atp.rateio_medico && atp.rateio_medico.unidade_operacao_nf && atp.rateio_medico.unidade_operacao_nf.st_sigla">
                                                    {{ atp.rateio_medico.unidade_operacao_nf.st_sigla }}
                                                </span>
                                            </td>
                                            <td class="text-right">{{ $util.formatMoeda(atp.cd_valor_total) }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colspan="5">Total</th>
                                            <th class="text-right">{{ $util.formatMoeda(lista_atendimentos.reduce((acc, atp) => acc + atp.cd_valor_total, 0)) }}</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                            <div class="card" v-if="false">
                                <div class="card-header">
                                    <a class="card-link" data-toggle="collapse" href="#collapseSplit" role="button" aria-expanded="false" aria-controls="collapseSplit">
                                        Detalhes
                                    </a>                                 
                                </div>
                                <div class="collapse" id="collapseSplit">
                                    <div class="card card-body">
                                        <hr>
                                        <pre>{{ split_zoop_valid.atendimentos }}</pre>
                                        <hr>
                                    </div>
                                    <div class="card card-body">
                                        <pre>{{ split_zoop_valid }}</pre>
                                    </div>
                                </div>
                            </div>                        
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Ver Splits -->
        <div class="modal fade" id="zoopFeitoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Splits Realizados</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body" v-if="split_realizado">
                        <div class="alert alert-info d-flex justify-content-between">
                            <div>
                                Recibo #{{ split_realizado.ipa.id_pagamento_atendimento }}
                                <div class="small text-muted" v-if="split_realizado.ipa && split_realizado.ipa.js_outros && split_realizado.ipa.js_outros.zoop && split_realizado.ipa.js_outros.zoop.transaction_id">
                                    {{ split_realizado.ipa.js_outros.zoop.transaction_id }}
                                </div>
                            </div>
                            <div class="text-right">
                                <div v-if="split_realizado.ipa && split_realizado.ipa.dc_valor">
                                    {{ $util.formatMoeda(split_realizado.ipa.dc_valor) }}
                                </div>
                                <div class="small text-right" v-if="split_realizado.ipa.forma_pagamento">
                                    {{ split_realizado.ipa.forma_pagamento.search }}
                                </div>
                            </div>
                        </div>

                        <table class="table table-sm table-hover">
                            <thead>
                                <tr>
                                    <th>Seller</th>
                                    <th class="text-right">Percentual</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(split, isx) in split_realizado.splits" :key="'R' + isx">
                                    <td>{{ split.recipient }}</td>
                                    <td class="text-right">{{ split.percentage }}%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <edicao-rateio-medico ref="cadrateio" :viewonly="true" />
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import EdicaoRateioMedico from '../../cadastros/shared/EdicaoRateioMedico.vue';

export default {
    data() {
        return { 
            split_zoop_valid: null,
            split_realizado: null, 
        }
    },

    components: {
        AzEmptyState,
        EdicaoRateioMedico,
    },

    computed: { 
        valor_total: function () { 
            let valor = 0; 
            
            if ( this.split_zoop_valid && this.split_zoop_valid.ipa && this.split_zoop_valid.ipa.dc_valor ) {
                valor += this.split_zoop_valid.ipa.dc_valor;
            }

            if ( this.split_zoop_valid && this.split_zoop_valid.realizados && this.split_zoop_valid.realizados.length ) {
                valor += this.split_zoop_valid.realizados.reduce((acc, r) => acc + r.dc_valor, 0);
            }

            return valor;
        },
        lista_atendimentos: function () { 
            if ( !this.split_zoop_valid || !this.split_zoop_valid.atendimentos || !this.split_zoop_valid.atendimentos.length ) 
                return [];
            

            return this.split_zoop_valid.atendimentos.flatMap(atend => {
                return atend.atendimento_procedimentos.map(ap => { 
                    if ( !ap.medico ) { 
                        ap.medico = atend.medico; 
                    }

                    ap.dt_inicio = atend.dt_inicio;

                    return ap; 
                });
            });
        }
    },  

    methods: { 

        ver_rateio (atp) { 
            this.$refs.cadrateio.editar(atp.id_rateio_medico);
        },

        ver_splits (lanc) { 
            console.log('ver_splts', lanc);

            let splits = _.get(lanc, 'item_pagamento_atendimento.js_outros.zoop.splits');

            console.log('splits', splits);

            if ( !splits || !splits.length ) { 
                this.$toast.add({ 
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Nenhum split realizado',
                    life: 5000
                })

                return; 
            }
            this.split_realizado = { 
                splits: _.cloneDeep(splits), 
                ipa: _.cloneDeep(lanc.item_pagamento_atendimento), 
            };

            $('#zoopFeitoModal').modal('show');
        },

        abrir (lanc) { 

            this.split_zoop_valid = null; 

            $('#zoopModal').modal('show');

            this.$util.atualizar(this, {
                service: 'financeiro',
                func: 'gerar_split_zoop',
                dados: {
                    lista: [
                        lanc.item_pagamento_atendimento.id_item_pagamento_atendimento
                    ],
                    valid: true, 
                },
                callback: res => { 
                    this.split_zoop_valid = { 
                        ...res,
                        ipa: lanc.item_pagamento_atendimento
                    };
                }
            });

        },

    }
}
</script>


